import { defineStore } from 'pinia';

export const usePopupStore = defineStore('popup', {
    state: () => ({
        isVisible: false,
        title: '',
        message: ''
    }),
    actions: {
        showPopup(title, message, height) {
            this.isVisible = true;
            this.title = title;
            this.message = message;
        },
        hidePopup() {
            this.isVisible = false;
            this.title = '';
            this.message = '';
        }
    }
});
